import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
let codeMANAGE = apiConstants.codeMANAGE;
let codeFRONT = apiConstants.codeFRONT;
let baseUrlAPI = apiConstants.baseUrlAPI || codeAPI;

const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        codeMANAGE: codeMANAGE,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp('central$'), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'COSI_00582',
                },
            },
            manage: {
                menu: {
                    route: `${codeMANAGE}.home`,
                    text: 'global.manage',
                    icon: 'fas fa-cogs'
                },
                acl: {
                    view: 'COSI_00006',
                },
            },
            communications: {
                menu: {
                    route: `${code}.communications`,
                    text: 'communications.titles',
                    icon: 'fas fa-phone',
                },
                panel: {
                    showLocalAddress: true,
                },
                acl: {
                    view: 'COSI_00710',
                    detail: 'COSI_00711',
                    add: 'COSI_00712',
                    edit: 'COSI_00713',
                    delete: 'COSI_00714',
                },
                url: {
                    getList: `${baseUrlAPI}/communications`,
                    getShow: `${baseUrlAPI}/communications/:id`,
                    getCreate: `${baseUrlAPI}/communications`,
                    getUpdate: `${baseUrlAPI}/communications/:id`,
                    getDelete: `${baseUrlAPI}/communications/:id`,

                    getLists: `${baseUrlAPI}/communications/auxiliaries`,
                    getShifts: `${baseUrlAPI}/communications/shifts/:date/:agent_id`,
                    getConnMe: `${baseUrlAPI}/communications/search/comm-me`,
                    getFamilyTypes: `${baseUrlAPI}/communications/search/type`,
                    getLocations: `${baseUrlAPI}/communications/search/locations`,
                    getSearchLists: `${baseUrlAPI}/communications/search/lists`,
                    getAddress: `../gateway/address/search`,
                    reverseAddress: `../gateway/address/reverse/:lat/:lon/:srid`,
                },
                constants: {
                    location: {
                        id: 'id',
                        name: 'name',
                        group: 'adminName1',
                        latitude: 'lat',
                        longitude: 'lng',
                        sird: 'srid',
                    },
                    address: {
                        id: 'id',
                        name: 'name',
                        group: 'adminName1',
                        district: 'adminName1',
                        municipality: 'adminName2',
                        parish: 'adminName3',
                        latitude: 'lat',
                        longitude: 'lng',
                        precisionCoordinates: 3,
                        linkCoordinates: 'https://maps.google.com/?q=:lat,:lng',
                    },
                    channels: {
                        alarm_center_services : 2,
                        alarm_center_teleassistance : 7,
                        radio_er : 12,
                        pcm_phone : 13,
                        presential : 16,
                    },
                    categories: {
                        occurrence: 1,
                        civil_protection_network: 2,
                        alarm: 3,
                        proximity_policing: 4,
                        inspection_action: 5,
                        update_processes: 6,
                        expedient_check: 7,
                        paid_service: 8,
                        dpm_other: 9,
                        cps_other: 10,
                        cp_occurrence: 12,
                        communication: 13,
                        sculptures: 15,
                        inspection_values: 16
                    },
                },
            },
            shifts: {
                menu: {
                    route: `${code}.shifts`,
                    text: 'shifts.titles',
                    icon: 'fas fa-calendar',
                },
                acl: {
                    view                    : 'COSI_00760',
                    detail                  : 'COSI_00761',
                    add                     : 'COSI_00762',
                    edit                    : 'COSI_00763',
                    delete                  : 'COSI_00764',
                    patrol: {
                        add                     : 'COSI_00762',
                        edit                    : 'COSI_00763',
                        delete                  : 'COSI_00764',
                        history                 : 'COSI_00761x',
                    }
                },
                url: {
                    getList                 : `${baseUrlAPI}/shifts`,
                    getShow                 : `${baseUrlAPI}/shifts/:id`,
                    getCreate               : `${baseUrlAPI}/shifts`,
                    getUpdate               : `${baseUrlAPI}/shifts/:id`,
                    getDelete               : `${baseUrlAPI}/shifts/:id`,
                    getAuxiliaries          : `${baseUrlAPI}/shifts/auxiliaries/:update`,
                    searchAgent             : `${baseUrlAPI}/shifts/search/agent/:graduate`,
                    searchRadio             : `${baseUrlAPI}/shifts/search/radio/portable`,
                },
            },
            report: {
                menu: {
                    route: `${code}.report`,
                    text: 'Relatórios',
                    icon: 'fas fa-chart-bar',
                },
                acl: {
                    view                    : 'COSI_00750',
                    detail                  : 'COSI_00751',
                },
                url: {
                    getList                              : `${baseUrlAPI}/reports`,
                    getShow                              : `${baseUrlAPI}/reports/:id`,
                    // getDpmServiceStaffData               : `${baseUrlAPI}/reports/ccc/service-staff`,
                    // getCcomAlarmData                     : `${baseUrlAPI}/reports/ccc/alarms`,
                    // getCcomCivilProtectionNetwork        : `${baseUrlAPI}/reports/ccc/civil-protection-network`,
                    // getCcomCommunicationsData            : `${baseUrlAPI}/reports/ccc/communications`,
                    // getCcomDailyReportData               : `${baseUrlAPI}/reports/ccc/daily-report`,
                    // getCcomOccurrencesLogData            : `${baseUrlAPI}/reports/ccc/occurrences`,

                    // getDpmInspectionsData                : `${baseUrlAPI}/reports/dpm/inspections`,
                    // getDpmProximityPoliceData            : `${baseUrlAPI}/reports/dpm/proximity-police`,
                    // getDpmSculpturesData                 : `${baseUrlAPI}/reports/dpm/sculptures`,
                    // getDpmProcessUpdateData              : `${baseUrlAPI}/reports/dpm/process-update`,
                    // getDpmDailyReportData                : `${baseUrlAPI}/reports/dpm/daily-report`,

                    getReportData                 : `${baseUrlAPI}/reports/:entity_code/:code`,
                },
            },
            agents: {
                menu: {
                    route: `${code}.agents`,
                    text: 'agents.titles',
                    icon: 'fas fa-users',
                },
                panel: {
                    maxFiles: 5,
                    mimeTypes: [
                        'application/msword',
                        'application/vnd.ms-excel',
                        'application/vnd.ms-powerpoint',
                        'application/pdf',
                        'text/plain',
                        'image/x-png',
                        'image/bmp',
                        'image/jpeg',
                        'image/jpg',
                        'image/gif',
                    ],
                },
                acl: {
                    view                    : 'COSI_00680',
                    detail                  : 'COSI_00681',
                    add                     : 'COSI_00682',
                    edit                    : 'COSI_00683',
                    delete                  : 'COSI_00684',
                },
                url: {
                    getList                 : `${baseUrlAPI}/agents`,
                    getShow                 : `${baseUrlAPI}/agents/:id`,
                    getCreate               : `${baseUrlAPI}/agents`,
                    getUpdate               : `${baseUrlAPI}/agents/:id`,
                    getDelete               : `${baseUrlAPI}/agents/:id`,
                    getLists                : `${baseUrlAPI}/agents/lists`,
                },
            },
            vehicles: {
                menu: {
                    route: `${code}.vehicles`,
                    text: 'vehicles.titles',
                    icon: 'fas fa-car',
                },
                acl: {
                    view                    : 'COSI_00690',
                    detail                  : 'COSI_00691',
                    add                     : 'COSI_00692',
                    edit                    : 'COSI_00693',
                    delete                  : 'COSI_00694',
                },
                url: {
                    getList                 : `${baseUrlAPI}/vehicles`,
                    getShow                 : `${baseUrlAPI}/vehicles/:id`,
                    getCreate               : `${baseUrlAPI}/vehicles`,
                    getUpdate               : `${baseUrlAPI}/vehicles/:id`,
                    getDelete               : `${baseUrlAPI}/vehicles/:id`,
                    getLists                : `${baseUrlAPI}/vehicles/lists/:update`,
                },
            },
            radios: {
                menu: {
                    route: `${code}.radios`,
                    text: 'radios.titles',
                    icon: 'fas fa-mobile-alt',
                },
                acl: {
                    view                    : 'COSI_00700',
                    detail                  : 'COSI_00701',
                    add                     : 'COSI_00702',
                    edit                    : 'COSI_00703',
                    delete                  : 'COSI_00704',
                },
                url: {
                    getList                 : `${baseUrlAPI}/radios`,
                    getShow                 : `${baseUrlAPI}/radios/:id`,
                    getCreate               : `${baseUrlAPI}/radios`,
                    getUpdate               : `${baseUrlAPI}/radios/:id`,
                    getDelete               : `${baseUrlAPI}/radios/:id`,
                    getLists                : `${baseUrlAPI}/radios/lists`,
                },
            },
            terrestrialresources: {
                active: false,
                menu: {
                    route: `${code}.terrestrialresources`,
                    text: 'terrestrialresources.titles',
                    icon: 'fas fa-th-large',
                },
                acl: {
                    view                    : 'COSI_00690',
                    detail                  : 'COSI_00691',
                    add                     : 'COSI_00692',
                    edit                    : 'COSI_00693',
                    delete                  : 'COSI_00694',
                },
                url: {
                    getList                 : `${baseUrlAPI}/terrestrialresources`,
                    getShow                 : `${baseUrlAPI}/terrestrialresources/:id`,
                    getCreate               : `${baseUrlAPI}/terrestrialresources`,
                    getUpdate               : `${baseUrlAPI}/terrestrialresources/:id`,
                    getDelete               : `${baseUrlAPI}/terrestrialresources/:id`,
                    getLists                : `${baseUrlAPI}/terrestrialresources/lists`,
                },
            },
            aerialresources: {
                active: false,
                menu: {
                    route: `${code}.aerialresources`,
                    text: 'aerialresources.titles',
                    icon: 'fas fa-helicopter',
                },
                acl: {
                    view                    : 'COSI_00690',
                    detail                  : 'COSI_00691',
                    add                     : 'COSI_00692',
                    edit                    : 'COSI_00693',
                    delete                  : 'COSI_00694',
                },
                url: {
                    getList                 : `${baseUrlAPI}/aerialresources`,
                    getShow                 : `${baseUrlAPI}/aerialresources/:id`,
                    getCreate               : `${baseUrlAPI}/aerialresources`,
                    getUpdate               : `${baseUrlAPI}/aerialresources/:id`,
                    getDelete               : `${baseUrlAPI}/aerialresources/:id`,
                    getLists                : `${baseUrlAPI}/aerialresources/lists`,
                },
            },
        },
        tools: {

        },
    },
};

export default state;
